<template>
  <div :class="{'spoiler-has-alert': hasAlert, 'd-inline': inlineSummary}" ref="spoiler">
    <div
      class="pointer"
      :class="{'noselect': noselect, 'd-inline': inlineSummary}"
      @click="toggle()"
    >
      <span class="caret-span">
        <i class="fa" :class="{'fa-caret-down': isOpen, 'fa-caret-right': !isOpen}"></i>
        &nbsp;
      </span>
      <slot name="summary">{{summary}}</slot>
      <i class="text-info">&nbsp;{{isOpen ? "(zwiń)" : "(rozwiń)"}}</i>
      <slot name="alert">
        <w-alert v-if="hasErrors" header alert-type="danger">Zawiera błędy!</w-alert>
      </slot>
    </div>
    <div v-show="isOpen" ref="content" :class="border ? 'content' : ''">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'w-spoiler',
  props: {
    summary: {
      type: String,
      default: 'spoiler'
    },
    noselect: {
      type: Boolean,
      default: true
    },
    border: {
      type: Boolean,
      default: true,
      required: false
    },
    open: {
      type: Boolean,
      default: false
    },
    inlineSummary: {
      type: Boolean,
      default: false
    }
  },
  data() {
    const isOpen = this.open;
    return {
      hasAlert: false,
      hasErrors: false,
      isOpen
    };
  },
  methods: {
    toggle() {
      this.isOpen = !this.isOpen;
    }
  },
  updated() {
    this.hasErrors = !!this.$refs.content.querySelector('[data-path$=".$error"]');
    this.hasAlert = !!this.$refs.spoiler.querySelector('div.alert') && this.hasErrors;
  },
  created() {
    this.$nextTick(() => {
      this.hasErrors = !!this.$refs.content.querySelector('[data-path$=".$error"]');
      this.hasAlert = !!this.$refs.spoiler.querySelector('div.alert') && this.hasErrors;
    });
  }
};
</script>

<style>
span.caret-span > i.fa {
  width: 7.438px;
}
.spoiler-has-alert {
  min-height: 60px;
}
.caret-span {
  display: inline-block;
}
.pointer {
  cursor: pointer;
}
.content ul,
.content ol {
  padding-left: 13px;
}
.content {
  padding-top: 9px;
  padding-bottom: 9px;
  padding-right: 19px;
  padding-left: 19px;

  border: 1px solid #ddd;
  border-top-color: rgb(221, 221, 221);
  border-top-style: solid;
  border-top-width: 1px;
  border-right-color: rgb(221, 221, 221);
  border-right-style: solid;
  border-right-width: 1px;
  border-bottom-color: rgb(221, 221, 221);
  border-bottom-style: solid;
  border-bottom-width: 1px;
  border-left-color: rgb(221, 221, 221);
  border-left-style: solid;
  border-left-width: 1px;
  border-image-source: initial;
  border-image-slice: initial;
  border-image-width: initial;
  border-image-outset: initial;
  border-image-repeat: initial;

  border-radius: 2px;
  border-top-left-radius: 2px;
  border-top-right-radius: 2px;
  border-bottom-right-radius: 2px;
  border-bottom-left-radius: 2px;
}
.noselect {
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none; /* Non-prefixed version, currently
                                  supported by Chrome and Opera */
}
</style>